export default function Section({ children, className }: any) {
  return <div className={`sol-section ${className || ""}`}>{children}</div>;
}
